import axios from "axios";
import { environment } from "environment/environment";
import { BrokerApiUrl } from "./BrokerApiUrl";

const brokerApi = axios.create({
  baseURL: `${environment.stockApiBaseUrl}${BrokerApiUrl.basePath}`,
  headers: { "Content-Type": "application/json" },
});

const unwrap = (response) => {
  const body = response?.data;
  if (body?.status === false) {
    throw new Error(body.message || "Broker operation failed");
  }
  return body?.data ?? null;
};

export const addBrokerAccount = async (payload) =>
  unwrap(await brokerApi.post(BrokerApiUrl.addBroker, payload));

export const updateBrokerAccount = async (id, payload) =>
  unwrap(await brokerApi.put(BrokerApiUrl.updateBroker(id), payload));

export const getBrokerAccounts = async (userId, brokerType) => {
  const response = await brokerApi.get(BrokerApiUrl.getAllBrokersByType, {
    params: { userId, ...(brokerType ? { brokerType } : {}) },
  });
  return unwrap(response) || [];
};

export const getBrokerAccount = async (id, userId) =>
  unwrap(
    await brokerApi.get(BrokerApiUrl.getBrokerByUserId, {
      params: { id, userId },
    })
  );

export const deleteBrokerAccount = async (id, userId) =>
  unwrap(
    await brokerApi.delete(BrokerApiUrl.deleteBrokerByUserId, {
      params: { id, userId },
    })
  );

export const connectBrokerAccount = async (id, userId) =>
  unwrap(
    await brokerApi.post(BrokerApiUrl.connectBroker, null, {
      params: { id, userId },
    })
  );

export const disconnectBrokerAccount = async (id, userId) =>
  unwrap(
    await brokerApi.post(BrokerApiUrl.disconnectBroker, null, {
      params: { id, userId },
    })
  );

export const getBrokerId = (broker) => broker?.id || broker?._id;
